import React from 'react';
import Text from './Text.js';
import Button from './Button.js';
import * as dates from "@simplybenefits/sb-dates";
import i18n from '../localization/i18n.js';
import tokens from '../localization/tokens.js';
import { localizationMaps } from '../index.js';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const MetaBlock = props => {
  const {
    showModal,
    data,
    disabled
  } = props;
  let asoDetails = i18n.t(tokens.labels.quotes.none);
  if (data.meta.aso && data.meta.aso.isASO) {
    if (data.meta.aso.isAsoDental && data.meta.aso.isAsoHealth) {
      asoDetails = i18n.t(tokens.labels.quotes.healthAndDental);
    } else if (data.meta.aso.isAsoDental) {
      asoDetails = i18n.t(tokens.labels.quotes.dentalOnly);
    } else if (data.meta.aso.isAsoHealth) {
      asoDetails = i18n.t(tokens.labels.quotes.healthOnly);
    }
    if (data.meta.aso.asoType === 'Arrears') {
      asoDetails = `${asoDetails} ${i18n.t(tokens.labels.quotes.inArrears)}`;
    } else {
      asoDetails = `${asoDetails} ${i18n.t(tokens.labels.quotes.budgeted)}`;
    }
  }
  const styles = {
    container: {
      display: 'flex',
      flex: 1,
      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
      padding: "10px 32px",
      zIndex: 2,
      height: 150,
      flexWrap: 'wrap',
      background: '#FFF'
    },
    main: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    },
    row: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      padding: "10px 0"
    },
    block: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    },
    addressBlock: {
      display: 'flex',
      flex: 1.25,
      flexDirection: 'column'
    }
  };

  /**
   * 
   * @param {*} param0 
   */
  const returnCompanyAddressForDisplay = ({
    addressLineOne,
    addressLineTwo,
    city,
    province,
    postalCode
  }) => {
    const address = [addressLineOne];
    if (addressLineTwo) {
      address.push(addressLineTwo);
    }
    address.push(city);
    address.push(localizationMaps.fromEnglish('provinces', province));
    address.push(postalCode);
    return address.join(', ');
  };
  return /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.main
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.row
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.labels.account.companyName)), /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, data.meta.company)), /*#__PURE__*/React.createElement("div", {
    style: styles.addressBlock
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.labels.account.companyEmail)), /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, data.meta.email)), /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.labels.phoneNumber)), /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, data.meta.phone)), /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.labels.account.signingAuthorityName)), /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, data.meta.authority.name))), /*#__PURE__*/React.createElement("div", {
    style: styles.row
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.labels.account.lastUpdated)), /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, dates.getLocalDisplay(data.meta.dateUpdated, 'MMMM DD, YYYY'))), /*#__PURE__*/React.createElement("div", {
    style: styles.addressBlock
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.labels.masterApplication.companyAddress)), /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, returnCompanyAddressForDisplay(data.meta))), /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.labels.account.asoDetails)), /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, asoDetails)), /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true
  }, i18n.t(tokens.labels.account.signingAuthorityEmail)), /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, data.meta.authority.email)))), !disabled && /*#__PURE__*/React.createElement(Button, {
    onClick: showModal,
    color: "primary",
    customStyle: {
      height: 25,
      textTransform: 'capitalize'
    }
  }, i18n.t(tokens.buttons.edit)));
};
export default MetaBlock;